const FeesContentTwo = () => {
  return (
    <div className="trading-guide-section">
      <div className="trading-container">
        {/* Main Heading */}
        {/* <div className="trading-header-row">
          <h2 className="trading-main-headline">
            Commissions & Spreads That Work for Every Trader
          </h2>
        </div> */}

        <div className="trading-visual-wrapper">
          <div className="trading-bg-image">
            <img
              src="/images/trading/fees/fees.png"
              alt="Trading Demo Account User"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesContentTwo;
